import { debug } from "./debugLogger";
/**
 * Utility functions for handling CloudFront URLs
 */

/**
 * Properly encodes a CloudFront URL to handle special characters in filenames
 * @param url The original CloudFront URL
 * @returns The encoded CloudFront URL
 */
export const encodeCloudFrontUrl = (url: string): string => {
  if (!url || typeof url !== "string") return "";
  const trimmed = url.trim();
  if (!trimmed) return "";

  try {
    // Extract the base URL and path
    const urlParts = trimmed.split('//');
    if (urlParts.length !== 2) return trimmed;
    
    const [protocol, rest] = urlParts;
    const [domain, ...pathParts] = rest.split('/');
    
    // If there's no path, return the original URL
    if (pathParts.length === 0) return trimmed;
    
    // Encode only the filename part (last segment)
    const path = pathParts.slice(0, -1).join('/');
    const filename = encodeURIComponent(pathParts[pathParts.length - 1]);
    
    // Reconstruct the URL
    return `${protocol}//${domain}/${path}/${filename}`;
  } catch (error) {
    debug.error('Error encoding CloudFront URL:', error);
    return trimmed; // Return trimmed URL if encoding fails
  }
};

/**
 * Gets the properly encoded CloudFront URL from a response
 * @param response The response containing the CloudFront URL
 * @returns The encoded CloudFront URL
 */
export const getEncodedCloudFrontUrl = (response: any): string => {
  const cloudFrontUrl = response?.cloudfront_url || '';
  return encodeCloudFrontUrl(cloudFrontUrl);
};
